import { useEffect, useMemo, useRef, useState } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { useSearchParams } from "react-router-dom";
import moment from "moment";

import SortIcon from "../ui-icons/table/SortIcon";
import { urlDefault } from "src/constants";
import { siteUrlOrSiteApi } from "src/api/config/systemSwitch";
import { useAppSelector } from "src/hooks/redux";
import { selectUsers } from "src/modules/users/selector";
import { EmptyList } from "../EmptyList";
import { UserAvatar } from "../ui/avatar/Avatar";
import { Statuses5WayNotice } from "src/pages/DashboardPage/throughcomponents/card5Way/components/statusesNotice/statusesNotice";
import { TooltipItem } from "src/utils/Tooltip";
import { selectItems } from "src/modules/spItems/selectors";
import { myTasks5WayStatusesListName, myTasksDeviationReportTriggersListName, myTasksTriggersListName } from "src/api/config/myTasksLists.config";

const MyTasksList5WayTable = (props: any) => {

    const { data, setExportData, customLoading, nextPage, type } = props;
    const [sortData, setSortData] = useState<any>([]);
    const [query, setQuery] = useSearchParams();
    const users: any = useAppSelector(selectUsers);
    const triggers: any = useAppSelector(state => selectItems(state, myTasksTriggersListName));
    const triggersDeviationReport: any = useAppSelector(state => selectItems(state, myTasksDeviationReportTriggersListName));
    const statuses5Way: any = useAppSelector(state => selectItems(state, myTasks5WayStatusesListName));
    const [tempTriggers, setTempTriggers] = useState<any>([]);

    const [tableHeaderContent, setTableHeaderContent] = useState<any>({});
    const [tableHeaderContentExel, setTableHeaderContentExel] = useState<any>({});

    const openDocumentCard = (id: number) => {
        const newSearchParams = new URLSearchParams(query);
        console.log('TYPE 5WAY:', type);
        newSearchParams.set((type === '5Way' || type === 'FiveWay') && "5WayCardMobile" || "deviationCardMobile", id.toString());
        setQuery(newSearchParams);
    }

    const sortDataHandle = (sortField: string, sortDirection: string, sortType: string) => {
        const tempTableHeaderContent = { ...tableHeaderContent };
        let tempData = [];
        if (type === '5Way') {
            tempData = [...data.map((item: any) => { return { ...item, ...{ actionsPlanStr: item.actionsPlan && 'Да' || 'Нет', RegionStr: item.Region.get_lookupValue(), DepartmentStr: item.Department.get_lookupValue(), LocationStr: item.Location.get_lookupValue(), TriggerStr: tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger).length > 0 && tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger)[0]['Title'], KpiStr: item.KPI.get_lookupValue(), StatusStr: item.Status && item.Status.get_lookupValue(), TreeStr: item.Tree && item.Tree.indexOf(`"root":true`) !== -1 && 'Да' || 'Нет', EditorsStr: users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()] && users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()]['displayName'] || '-' } } })];
        } else {
            tempData = [...data.map((item: any) => { return { ...item, ...{ actionsPlanStr: item.actionsPlan && 'Да' || 'Нет', RegionStr: item.Region.get_lookupValue(), DepartmentStr: item.Department.get_lookupValue(), LocationStr: item.Location.get_lookupValue(), TriggerStr: tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger).length > 0 && tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger)[0]['Title'], KpiStr: item.KPI.get_lookupValue(), StatusStr: item.Status && item.Status.get_lookupValue(), TreeStr: item.Tree && item.Tree.indexOf(`"root":true`) !== -1 && 'Да' || 'Нет' } } })];
        }
        Object.keys(tempTableHeaderContent).map((key: string) => {
            tempTableHeaderContent[key]['sortDirection'] = 'default';
        });
        if (sortDirection === 'default') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'desc';
        }
        if (sortDirection === 'desc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'asc';
        }
        if (sortDirection === 'asc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'default';
            setSortData([...data]);
        }
        if (sortType === 'number') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => parseFloat(a[sortField]) - parseFloat(b[sortField]));
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => parseFloat(b[sortField]) - parseFloat(a[sortField]));
            }
        }
        if (sortType === 'string') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => {
                    return a[sortField].localeCompare(b[sortField]);
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => {
                    return b[sortField].localeCompare(a[sortField]);
                });
            }
        }
        if (sortType === 'date') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateA.getTime() - dateB.getTime();
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateB.getTime() - dateA.getTime();
                });
            }
        }
        setTableHeaderContent({ ...tempTableHeaderContent });
        setSortData([...tempData]);
    }

    useEffect(() => {
        setSortData([...data]);
        const tempTableHeaderContent = { ...tableHeaderContent };
        Object.keys(tempTableHeaderContent).length > 0 && Object.keys(tempTableHeaderContent).map((key: string) => {
            tempTableHeaderContent[key]['sortDirection'] = 'default';
        });
        setTableHeaderContent({ ...tempTableHeaderContent });
    }, [data]);

    useEffect(() => {
        if (sortData.length > 0) {
            let exportColumns: any = [];
            Object.keys(tableHeaderContentExel).length > 0 && Object.keys(tableHeaderContentExel).map((key: any) => {
                exportColumns = [...exportColumns, {
                    header: tableHeaderContentExel[key]['title'],
                    key: key,
                    width: tableHeaderContentExel[key]['width']
                }]
            });
            let exportData: any = [];
            if (type === '5Way') {
                sortData.forEach((item: any) => {
                    exportData = [...exportData, {
                        Description: {
                            text: item.Description,
                            hyperlink: type === '5Way' && `${siteUrlOrSiteApi}${urlDefault}/dashboard/3/5-whys?5WayCardMobile=${item.ID}` || `${siteUrlOrSiteApi}${urlDefault}/dashboard/3/deviation-reports?deviationCardMobile=${item.ID}`,
                            tooltip: item.Description
                        },
                        Date5Way: moment(item.Date5Way).format('DD.MM.YYYY'),
                        Location: item.Location.get_lookupValue(),
                        Department: item.Department.get_lookupValue(),
                        Region: item.Region.get_lookupValue(),
                        Trigger: tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger).length > 0 && tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger)[0]['Title'],
                        KPI: item.KPI.get_lookupValue(),
                        Editors: users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()] && users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()]['displayName'] || '-',
                        Status: item.Status && item.Status.get_lookupValue(),
                        Tree: item.Tree && item.Tree.indexOf(`"root":true`) !== -1 && 'Да' || 'Нет',
                        actionsPlan: (typeof item.actionsPlan == "boolean" && item.actionsPlan && 'Да' || 'Нет') || item.actionsPlan,
                    }]
                });
            } else {
                sortData.forEach((item: any) => {
                    exportData = [...exportData, {
                        Description: {
                            text: item.Description,
                            hyperlink: type === '5Way' && `${siteUrlOrSiteApi}${urlDefault}/dashboard/3/5-whys?5WayCardMobile=${item.ID}` || `${siteUrlOrSiteApi}${urlDefault}/dashboard/3/deviation-reports?deviationCardMobile=${item.ID}`,
                            tooltip: item.Description
                        },
                        Date5Way: moment(item.Date5Way).format('DD.MM.YYYY'),
                        Location: item.Location.get_lookupValue(),
                        Department: item.Department.get_lookupValue(),
                        Region: item.Region.get_lookupValue(),
                        Trigger: tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger).length > 0 && tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger)[0]['Title'],
                        KPI: item.KPI.get_lookupValue(),
                        Status: item.Status && item.Status.get_lookupValue(),
                        Tree: item.Tree && item.Tree.indexOf(`"root":true`) !== -1 && 'Да' || 'Нет',
                        actionsPlan: (typeof item.actionsPlan == "boolean" && item.actionsPlan && 'Да' || 'Нет') || item.actionsPlan,
                    }]
                });
            }
            setExportData({ columns: [...exportColumns], data: [...exportData] });
        }
    }, [sortData, users]);

    useEffect(() => {
        if (triggersDeviationReport.length > 0 || triggers.length > 0) {
            if (type === '5Way') {
                setTempTriggers([...triggers]);
            } else {
                setTempTriggers([...triggersDeviationReport]);
            }
        }
    }, [type, triggersDeviationReport, triggers])

    useEffect(() => {
        if (type === '5Way') {
            setTableHeaderContent({
                Description: {
                    title: "Краткое описание",
                    sort: true,
                    style: { width: "12.83%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                Date5Way: {
                    title: "Дата создания",
                    sort: true,
                    style: { width: "8.33%" },
                    sortDirection: 'default',
                    sortType: 'date'
                },
                LocationStr: {
                    title: "Локация",
                    sort: true,
                    style: { width: "8.15%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                DepartmentStr: {
                    title: "Отдел",
                    sort: true,
                    style: { width: "7.22%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                RegionStr: {
                    title: "Участок",
                    sort: true,
                    style: { width: "7.92%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                TriggerStr: {
                    title: "Триггер 5Почему",
                    sort: true,
                    style: { width: "12.86%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                KpiStr: {
                    title: "KPI",
                    sort: true,
                    style: { width: "7%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                EditorsStr: {
                    title: "Ответственный",
                    sort: true,
                    style: { width: "8.34%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                StatusStr: {
                    title: "Статус",
                    sort: true,
                    style: { width: "8.4%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                TreeStr: {
                    title: "Корневая причина выявлена",
                    sort: true,
                    style: { width: "9.21%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                actionsPlanStr: {
                    title: "Действия запланированы",
                    sort: true,
                    style: { width: "9.74%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
            })
            setTableHeaderContentExel({
                Description: {
                    title: "Краткое описание",
                    width: 50
                },
                Date5Way: {
                    title: "Дата создания",
                    width: 50
                },
                Location: {
                    title: "Локация",
                    width: 50
                },
                Department: {
                    title: "Отдел",
                    width: 50
                },
                Region: {
                    title: "Участок",
                    width: 50
                },
                Trigger: {
                    title: type === '5Way' && "Триггер 5Почему" || "Триггер Отчета об отклонениях",
                    width: 50
                },
                KPI: {
                    title: "KPI",
                    width: 50
                },
                Editors: {
                    title: "Ответственный",
                    width: 50
                },
                Status: {
                    title: "Статус",
                    width: 50
                },
                Tree: {
                    title: "Корневая причина выявлена",
                    width: 50
                },
                actionsPlan: {
                    title: "Действия запланированы",
                    width: 50
                }
            })
        } else {
            setTableHeaderContent({
                Description: {
                    title: "Краткое описание",
                    sort: true,
                    style: { width: "12.83%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                Date5Way: {
                    title: "Дата создания",
                    sort: true,
                    style: { width: "8.33%" },
                    sortDirection: 'default',
                    sortType: 'date'
                },
                LocationStr: {
                    title: "Локация",
                    sort: true,
                    style: { width: "8.15%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                DepartmentStr: {
                    title: "Отдел",
                    sort: true,
                    style: { width: "7.22%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                RegionStr: {
                    title: "Участок",
                    sort: true,
                    style: { width: "7.92%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                TriggerStr: {
                    title: "Триггер Отчета об отклонениях",
                    sort: true,
                    style: { width: "17.03%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                KpiStr: {
                    title: "KPI",
                    sort: true,
                    style: { width: "7%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                StatusStr: {
                    title: "Статус",
                    sort: true,
                    style: { width: "8.4%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                TreeStr: {
                    title: "Корневая причина выявлена",
                    sort: true,
                    style: { width: "13.38%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
                actionsPlanStr: {
                    title: "Действия запланированы",
                    sort: true,
                    style: { width: "9.74%" },
                    sortDirection: 'default',
                    sortType: 'string'
                },
            })
            setTableHeaderContentExel({
                Description: {
                    title: "Краткое описание",
                    width: 50
                },
                Date5Way: {
                    title: "Дата создания",
                    width: 50
                },
                Location: {
                    title: "Локация",
                    width: 50
                },
                Department: {
                    title: "Отдел",
                    width: 50
                },
                Region: {
                    title: "Участок",
                    width: 50
                },
                Trigger: {
                    title: type === '5Way' && "Триггер 5Почему" || "Триггер Отчета об отклонениях",
                    width: 50
                },
                KPI: {
                    title: "KPI",
                    width: 50
                },
                Status: {
                    title: "Статус",
                    width: 50
                },
                Tree: {
                    title: "Корневая причина выявлена",
                    width: 50
                },
                actionsPlan: {
                    title: "Действия запланированы",
                    width: 50
                }
            })
        }
    }, [type])

    return (
        <FlexCol className="w-full">
            <FlexCol className="relative">
                <FlexCol id="owd_calendar_wrapper" className="relative pb-5 overflow-x-hidden bg-white rounded-lg table-custom shadow-custom no-scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-210px)] min-h-[170px]">
                    <FlexRow className="pb-5 sticky-custom max-h-[65px] w-full bg-white pt-5 px-10 gap-5 z-10 hidden">
                        {Object.keys(tableHeaderContent).length > 0 && Object.keys(tableHeaderContent).map((fieldKey) => {
                            const key: string = fieldKey;
                            return (
                                <TableHeaderColumn
                                    key={fieldKey}
                                    sortField={fieldKey}
                                    tableHeaderContent={tableHeaderContent[key]}
                                    sortDataHandle={sortDataHandle}
                                />
                            );
                        })}
                    </FlexRow>
                    <FlexCol className="divide-y grow w-full px-[8px]">
                        {sortData.map((item: any) => (
                            <FlexCol
                                className="py-4 -mx-2 pl-[26px] pr-2 gap-[4px] cursor-pointer text-[#637381] hover:bg-[#F3F4F6]"
                                key={item.ID}
                                onClick={() => openDocumentCard(item.ID)}
                            >
                                <FlexRow style={{ width: "100%" }} className="break-words text-[#012169] mb-[4px] relative gap-[8px] items-start">
                                    <TooltipItem wrapperClassName="flex shrink-0" position="bottom-left" tooltipsReactNode={<Statuses5WayNotice type5Way={type} />} tooltipsText="">
                                        <div className="flex items-center shrink-0 pt-[6px]">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                <circle
                                                    cx="5"
                                                    cy="5"
                                                    r="5"
                                                    fill={
                                                        (item.Status_x003a_Color && item.Status_x003a_Color.get_lookupValue && item.Status_x003a_Color.get_lookupValue()) ||
                                                        (item.Status && statuses5Way && statuses5Way.find((s: any) => s.ID === item.Status.get_lookupId()) && statuses5Way.find((s: any) => s.ID === item.Status.get_lookupId()).Color) ||
                                                        "#D1D5DB"
                                                    }
                                                />
                                            </svg>
                                        </div>
                                    </TooltipItem>
                                    <div
                                        className="line-clamp-2"
                                        dangerouslySetInnerHTML={{
                                            __html: item.Description.replace(
                                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                                '<span style="color: rgb(0,98,155)">$&</span>'
                                            ),
                                        }}
                                    />
                                </FlexRow>
                                <FlexRow style={{ width: "100%" }} className="break-words items-center gap-[5px] text-[13px]">
                                    Дата создания
                                    <span className="block text-sm font-normal not-italic">{moment(item.Date5Way).format('DD.MM.YYYY')}</span>
                                </FlexRow>
                                <FlexRow style={{ width: "100%" }} className="break-words text-[13px] justify-start">
                                    <span className="block text-sm font-normal not-italic w- text-[13px]">
                                        {item.Location.get_lookupValue()} /
                                        {item.Department.get_lookupValue()} /
                                        {item.Region.get_lookupValue()}
                                    </span>
                                </FlexRow>
                                {/* <FlexCol style={{ width: "100%" }} className="break-words text-[13px]">
                                    <span className="block text-sm font-normal not-italic">{item.Department.get_lookupValue()}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "100%" }} className="break-words text-[13px]">
                                    <span className="block text-sm font-normal not-italic">{item.Region.get_lookupValue()}</span>
                                </FlexCol> */}
                                {/* <FlexCol style={{ width: "100%" }} className="break-words text-[13px]">
                                    <span className="block text-sm font-normal not-italic">{tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger).length > 0 && tempTriggers.filter((trigger: any) => trigger.ID === item.Trigger)[0]['Title']}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "100%" }} className="break-words text-[13px]">
                                    <span className="block text-sm font-normal not-italic">{item.KPI.get_lookupValue()}</span>
                                </FlexCol>
                                {type === '5Way' &&
                                    <FlexCol style={{ width: "100%" }} className="break-words">
                                        <span className="block text-sm font-normal not-italic"><div className="w-full flex items-center gap-2">
                                            <UserAvatar
                                                avatar={users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()] && users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()].avatar}
                                                shortName={users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()] && users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()].shortName}
                                                displayName={users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()] && users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()].displayName}
                                                email={item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()}
                                            />
                                            <div className="flex flex-col justify-center items-start">
                                                <span className="text-sm text-[#111928]">{users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()] && users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()].displayName}</span>
                                                <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()] && users[item.Editors.split(";")[item.Editors.split(";").length - 1].toLowerCase()].jobTitle }} />
                                            </div>
                                        </div></span>
                                    </FlexCol>
                                } */}
                                {/* <FlexCol style={{ width: "100%" }} className="break-words">
                                    <TooltipItem wrapperClassName="w-full sm:w-[542px] flex justify-end" position="bottom-left" tooltipsReactNode={<Statuses5WayNotice type5Way={type} />} tooltipsText="">
                                        <div className="w-full flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                <circle cx="5" cy="5" r="5" fill={item.Status && item.Status_x003a_Color.get_lookupValue()} />
                                            </svg>
                                            &nbsp;&nbsp;{item.Status && item.Status.get_lookupValue()}
                                        </div>
                                    </TooltipItem>
                                </FlexCol> */}
                                <FlexRow style={{ width: "100%" }} className="break-words text-[13px]">
                                    Корневая причина выявлена:&nbsp;
                                    <span className="block text-sm font-normal not-italic text-[13px]">{item.Tree && item.Tree.indexOf(`"root":true`) !== -1 && 'Да' || 'Нет'}</span>
                                </FlexRow>
                                <FlexRow style={{ width: "100%" }} className="break-words text-[13px]">
                                    Действия запланированы:&nbsp;
                                    <span className="block text-sm font-normal not-italic text-[13px]">{item.actionsPlan && 'Да' || 'Нет'}</span>
                                </FlexRow>
                            </FlexCol>
                        ))}
                    </FlexCol>
                    {!customLoading && data.length === 0 &&
                        <FlexCol className="justify-center items-center absolute pt-[60px] top-0 left-0 w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)]">
                            <EmptyList title="Данные не найдены" />
                        </FlexCol>
                    }
                </FlexCol>
                {/* {!customLoading && data.length > 0 && <div className="w-full my-2 py-2 text-center bg-[#012169] text-white">Список сформирован</div>} */}
                {/* {customLoading && <div className="w-full my-2 py-2 text-center animate-pulse">Формируется список, пожалуйста подождите</div>} */}
            </FlexCol>
        </FlexCol>
    );
}

export default MyTasksList5WayTable;

export function TableHeaderColumn({ tableHeaderContent, sortDataHandle, sortField }: any) {
    return (
        <FlexCol className="select-none" style={tableHeaderContent.style}>
            <FlexRow className="gap-x-2">
                {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
                <FlexCol className="font-medium whitespace-pre-line w-fit">{tableHeaderContent.title}</FlexCol>
                {tableHeaderContent.sort && (
                    <FlexCol className="w-auto cursor-pointer" onClick={() => sortDataHandle(sortField, tableHeaderContent.sortDirection, tableHeaderContent.sortType)}>
                        <SortIcon sortDirection={tableHeaderContent.sortDirection} />
                    </FlexCol>
                )}
            </FlexRow>
        </FlexCol>
    );
}
